import styled, { css } from "styled-components";
export const Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-1k68m4r-0"
})(["", " &.invalid{border:solid 2px red;}&.invalid:focus{background-color:#FFCCCC;}"], props => props.error ? css(["border:solid 2px red;&:focus{background-color:#FFCCCC;}"]) : null);